// extracted by mini-css-extract-plugin
export var link = "style-module--link--2bRFS";
export var link_l = "style-module--link_l--3CUdE";
export var link_r = "style-module--link_r--27dgX";
export var link_title = "style-module--link_title--3a_Jj";